import { TMazePosition } from "../../../../../../types/NY2025.interface";

export const mazeSize = 29;

export const mazeEntrance: TMazePosition = { x: 7, y: 3 };
export const mazeExit: TMazePosition = { x: 23, y: 20 };

export const mazeEmptyCells = 8;
